import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ShoppingBags({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ShoppingBags</title>
      <path
        d="M15 21.75C15.4142 21.75 15.75 21.4142 15.75 21C15.75 20.5858 15.4142 20.25 15 20.25V21.75ZM14.25 10.5C14.25 10.9142 14.5858 11.25 15 11.25C15.4142 11.25 15.75 10.9142 15.75 10.5H14.25ZM4 7.75H14V6.25H4V7.75ZM15 20.25H5V21.75H15V20.25ZM3.75 19V8H2.25V19H3.75ZM14.25 8V10.5H15.75V8H14.25ZM5 20.25C4.30964 20.25 3.75 19.6904 3.75 19H2.25C2.25 20.5188 3.48122 21.75 5 21.75V20.25ZM14 7.75C14.1381 7.75 14.25 7.86193 14.25 8H15.75C15.75 7.0335 14.9665 6.25 14 6.25V7.75ZM4 6.25C3.0335 6.25 2.25 7.0335 2.25 8H3.75C3.75 7.86193 3.86193 7.75 4 7.75V6.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M9 12C9 11.4477 9.44772 11 10 11H20C20.5523 11 21 11.4477 21 12V19C21 20.1046 20.1046 21 19 21H11C9.89543 21 9 20.1046 9 19V12Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 7C11.25 7.41421 11.5858 7.75 12 7.75C12.4142 7.75 12.75 7.41421 12.75 7H11.25ZM5.25 7C5.25 7.41421 5.58579 7.75 6 7.75C6.41421 7.75 6.75 7.41421 6.75 7H5.25ZM11.25 6V7H12.75V6H11.25ZM6.75 7V6H5.25V7H6.75ZM9 3.75C10.2426 3.75 11.25 4.75736 11.25 6H12.75C12.75 3.92893 11.0711 2.25 9 2.25V3.75ZM9 2.25C6.92893 2.25 5.25 3.92893 5.25 6H6.75C6.75 4.75736 7.75736 3.75 9 3.75V2.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.75 14C13.75 13.5858 13.4142 13.25 13 13.25C12.5858 13.25 12.25 13.5858 12.25 14L13.75 14ZM17.75 14C17.75 13.5858 17.4142 13.25 17 13.25C16.5858 13.25 16.25 13.5858 16.25 14L17.75 14ZM13.75 15L13.75 14L12.25 14L12.25 15L13.75 15ZM16.25 14L16.25 15L17.75 15L17.75 14L16.25 14ZM15 16.25C14.3096 16.25 13.75 15.6904 13.75 15L12.25 15C12.25 16.5188 13.4812 17.75 15 17.75L15 16.25ZM15 17.75C16.5188 17.75 17.75 16.5188 17.75 15L16.25 15C16.25 15.6904 15.6904 16.25 15 16.25L15 17.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
